import keyMirror from '../../../utils/keyMirror';

export const DATE_FILTER = keyMirror({
    BY_TODAY: null,
    BY_WEEK: null,
    BY_RANGE: null
});

export const WEEK = keyMirror({
    PREVIOUS: null,
    CURRENT: null,
    NEXT: null
});

export const DEFAULT_FILTER = {
	dateFilter: {
		type: DATE_FILTER.BY_TODAY,
		value: {
			[DATE_FILTER.BY_TODAY]: '',
			[DATE_FILTER.BY_WEEK]: WEEK.CURRENT,
			[DATE_FILTER.BY_RANGE]: {
				startDate: '',
				endDate: ''
			}
		}
	},
	"gangIds": []
};